import { Box, Divider, Typography } from "@mui/material";
import { SocialIcon } from "react-social-icons";

export default function Footer() {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: 'center', mt: 10, backgroundColor: "#FCF8F3", p: 2 }}>
            <Box sx={{ display: "flex", width: '100%', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Typography variant="h6" color={"#E39B3B"}>Contacteer ons</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        textAlign: "center",
                        fontSize: "18px",
                    }} color={"#3B3026"}>trimsalonminimax@icloud.com</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        textAlign: "center",
                        fontSize: "18px",
                    }} color={"#3B3026"}>(+32) 471 42 06 13</Typography>
                </Box>
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Typography variant="h6" color={"#E39B3B"}>Locatie</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        textAlign: "center",
                        fontSize: "18px",
                    }} color={"#3B3026"}>Bethaniëlei 92</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        textAlign: "center",
                        fontSize: "18px",
                    }} color={"#3B3026"}>2930, Brasschaat België</Typography>
                </Box>
            </Box>
            <Divider color="#E39B3B" sx={{mr: 20, ml: 20, mt: 2, mb: 2}} flexItem={true} variant="middle" />
            <Box sx={{ display: "flex", flexDirection: "row"}}>
                <SocialIcon style={{margin: "5px"}} url="https://www.instagram.com/trimsalonminimax/"/>
                <SocialIcon style={{margin: "5px"}} url="https://www.facebook.com/trimsalonminimax" />
            </Box>
        </Box>
    );
}